(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ConfirmationController = (function(superClass) {
    extend(ConfirmationController, superClass);

    function ConfirmationController(scope, transitions, state, generate, window, timeout) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.generate = generate;
      this.window = window;
      this.timeout = timeout;
      this.checkTabData = bind(this.checkTabData, this);
      this.setTabData = bind(this.setTabData, this);
      this.activateTab = bind(this.activateTab, this);
      this.tabSwitch = bind(this.tabSwitch, this);
      this.countValidTabs = bind(this.countValidTabs, this);
      this.handleAutoSelect = bind(this.handleAutoSelect, this);
      this.processTabData = bind(this.processTabData, this);
      this.handleProcessing = bind(this.handleProcessing, this);
      this.inputFileProcessed = bind(this.inputFileProcessed, this);
      this.checkForDataByTab = bind(this.checkForDataByTab, this);
      this.conversionRequestSent = bind(this.conversionRequestSent, this);
      this.close = bind(this.close, this);
      ConfirmationController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.ui = {
        table: {
          columns: false,
          belongs_to: false
        },
        loaded: false,
        info_text: 'Please select a tab.'
      };
      this.scope.children_hidden = [];
      this.scope.rows = [];
      this.scope.tabSwitch = this.tabSwitch;
      this.scope.tabs = {};
      this.window.inputFileProcessed = this.inputFileProcessed;
      this.window.conversionRequestSent = this.conversionRequestSent;
      this.scope.close = this.close;
      this.checkForDataByTab();
      this.scope.$on('uploads:processing', (function(_this) {
        return function() {
          if (_this.state.current.url !== '/confirmation' && _this.state.current.name.includes('confirm')) {
            _this.state.go('^');
          }
          return _this.checkForDataByTab();
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          var ref, ref1;
          if (_this.state.includes('grower.data.view')) {
            _this.scope.$emit('data_fullpage:hide');
          }
          if ((ref = App.sidebar) != null) {
            ref.open();
          }
          return (ref1 = App.angularSidebar) != null ? ref1.open() : void 0;
        };
      })(this));
    }

    ConfirmationController.prototype.close = function() {
      var ref, ref1;
      this.scope.$emit('data_fullpage:hide');
      if ((ref = App.sidebar) != null) {
        ref.open();
      }
      if ((ref1 = App.angularSidebar) != null) {
        ref1.open();
      }
    };

    ConfirmationController.prototype.conversionRequestSent = function(data) {
      return this.scope.$emit('uploads:processing');
    };

    ConfirmationController.prototype.checkForDataByTab = function() {
      return this.generate.checkForDataByTab().then((function(_this) {
        return function(response) {
          if (response.data.status.type = 'success') {
            _this.processTabData(response.data.data.counts);
            if (!response.data.data.processing.finished) {
              return _this.handleProcessing(response.data.data.processing);
            } else {
              _this.scope.tabs['processing'] = false;
              return _this.handleAutoSelect();
            }
          }
        };
      })(this));
    };

    ConfirmationController.prototype.inputFileProcessed = function(data) {
      return this.generate.checkForDataByTab().then((function(_this) {
        return function(response) {
          _this.processTabData(response.data.data.counts);
          return _this.handleProcessing(response.data.data.processing);
        };
      })(this));
    };

    ConfirmationController.prototype.handleProcessing = function(data) {
      this.scope.processing = data.processing;
      this.scope.total = data.total;
      this.scope.processed = this.scope.total - this.scope.processing;
      this.scope.tabs['processing'] = data.finished ? false : true;
      if (data.finished) {
        this.scope.tabs['processing'] = false;
        return this.scope.ui.info_text = 'Please select a tab.';
      } else {
        this.scope.tabs['processing'] = true;
        return this.scope.ui.info_text = 'Uploaded data is still processing. Tabs will be available once all data has finished processing.';
      }
    };

    ConfirmationController.prototype.processTabData = function(counts) {
      var data, results, tab;
      results = [];
      for (tab in counts) {
        data = counts[tab];
        results.push(this.setTabData(tab, data));
      }
      return results;
    };

    ConfirmationController.prototype.handleAutoSelect = function() {
      var obj, ref, results, tab;
      if (this.countValidTabs() === 1) {
        ref = this.scope.tabs;
        results = [];
        for (tab in ref) {
          obj = ref[tab];
          if (obj.data) {
            results.push(this.tabSwitch(tab));
          } else {
            results.push(void 0);
          }
        }
        return results;
      }
    };

    ConfirmationController.prototype.countValidTabs = function() {
      var obj, ref, tab, valid;
      valid = 0;
      ref = this.scope.tabs;
      for (tab in ref) {
        obj = ref[tab];
        if (obj.data) {
          valid += 1;
        }
      }
      return valid;
    };

    ConfirmationController.prototype.tabSwitch = function(tab) {
      if (tab === 'management_zone' || tab === 'mmz') {
        this.activateTab('mmz');
      }
      return this.activateTab(tab);
    };

    ConfirmationController.prototype.activateTab = function(tab) {
      return this.timeout((function(_this) {
        return function() {
          return _this.state.go("grower.data.add.upload.confirm." + tab);
        };
      })(this), 100);
    };

    ConfirmationController.prototype.setTabData = function(tab, data) {
      if (tab === 'Yield') {
        this.scope.tabs['yield'] = this.checkTabData(data);
      }
      if (tab === 'As-Planted') {
        this.scope.tabs['planting'] = this.checkTabData(data);
      }
      if (tab === 'Management Zone') {
        return this.scope.tabs['mmz'] = this.checkTabData(data);
      }
    };

    ConfirmationController.prototype.checkTabData = function(data) {
      if (data.unconfirmed) {
        return {
          unconfirmed: true,
          data: true
        };
      }
      return {
        unconfirmed: false,
        data: data.all > 0
      };
    };

    return ConfirmationController;

  })(Controller);

}).call(this);
